import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import ConsoleDialog from './ConsoleDialog'

function MintedPreview({ item, t }) {
    const [imageFailed, setImageFailed] = useState(false)
    const showImage = item.url && !imageFailed

    return <article className="mint-success-card" data-testid="minted-nft-preview">
        <div className="mint-success-card__media">
            {item.loading
                ? <i className="fa fa-spinner loading-css" aria-label={t('读取元数据')} />
                : showImage
                    ? <img src={item.url} alt={item.name || `NFT #${item.id}`} onError={() => setImageFailed(true)} />
                    : <i className="fa fa-cube" />}
        </div>
        <div className="mint-success-card__copy">
            <strong>#{item.id}</strong>
            <span>{item.name || `NFT #${item.id}`}</span>
        </div>
    </article>
}

export default function SuccessModal({ show, count = 0, items = [], remainingCount = 0, handleClose, onViewAll }) {
    const { t } = useTranslation()
    const total = count || items.length || 1
    const isSinglePreview = items.length === 1
    const translateCount = (key, value) => t(key, { count: value }).replace('{{count}}', String(value))
    const title = translateCount('成功铸造 {{count}} 枚 NFT', total)

    return <ConsoleDialog
        show={show}
        onClose={handleClose}
        title={title}
        description={t('本次铸造的 NFT 已写入当前钱包')}
        icon="fa-check"
        tone="success"
        closeLabel={t('关闭')}
        className={`mint-success-dialog${isSinglePreview ? ' is-single' : ''}`}
        footer={<>
            <button type="button" className="console-button is-secondary" onClick={handleClose}>{t('关闭')}</button>
            <button type="button" className="console-button is-primary" onClick={onViewAll}>{t('查看我的 NFT')}</button>
        </>}
    >
        <div className="mint-success-summary">
            <span><i className="fa fa-check" /></span>
            <div><strong>{total}</strong><small>NFT</small></div>
        </div>
        <div className={`mint-success-grid${isSinglePreview ? ' is-single' : ''}`} data-testid="mint-success-grid">
            {items.map((item) => <MintedPreview key={item.id} item={item} t={t} />)}
        </div>
        {remainingCount > 0 && <p className="mint-success-more">{translateCount('另外 {{count}} 枚已成功铸造', remainingCount)}</p>}
    </ConsoleDialog>
}
